let TABS = [
  {
    active: false,
    glyphicon: 'glyphicon-pencil',
    title: 'LEFT_NAV_EDIT',
    stateName: 'home.edit'
  },
  {
    active: false,
    glyphicon: 'glyphicon-dashboard',
    title: 'LEFT_NAV_DASHBOARD',
    stateName: 'home.dashboard'
  },
  {
    active: false,
    glyphicon: 'glyphicon-warning-sign',
    title: 'LEFT_NAV_ERRORS_AND_WARNINGS',
    stateName: 'home.batchErrors'
  },
  {
    active: false,
    icon: 'upload_icon',
    title: 'LEFT_NAV_SYNC_SETTINGS',
    stateName: 'home.syncSettings({tabName: "syncSchedule"})'
  },
  {
    active: false,
    glyphicon: 'glyphicon-certificate',
    title: 'LEFT_NAV_ASSIGN',
    stateName: 'home.assign.productsSelector'
  },
  {
    active: false,
    glyphicon: 'glyphicon-map-marker',
    title: 'LEFT_NAV_CREATE',
    stateName: 'home.create({tabName: "createCustomer"})'
  },
  {
    active: false,
    glyphicon: 'glyphicon-list-alt',
    title: 'LEFT_NAV_DATA_BROWSER',
    stateName: 'home.databrowser'
  },
  {
    active: false,
    glyphicon: 'glyphicon-wrench',
    title: 'LEFT_NAV_ADMIN_TOOLS',
    stateName: 'home.tools'
  }
];

export default TABS;



// WEBPACK FOOTER //
// ./app/models/tabs.js